<template>
  <div
    id="imMenu"
    class="collapse width im-navbar-collapse"
    :class="{ show: menuState.displayMenu }"
  >
    <h4>
      {{ $t("common.menu_title") }}
      <button class="navbar-toggler js-toggle" type="button" @click.stop.prevent="hideMenu">
        <span class="fas fa-angle-right ms-1 me-1"></span>
      </button>
    </h4>

    <h5>{{ $t("nav.about") }}</h5>
    <ul class="navbar-nav me-auto mt-2 mt-lg-0">
      <li class="nav-item active">
        <router-link class="nav-link" to="/services" @click.stop.prevent="gotoServices">{{
          $t("nav.services")
        }}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/clients" @click.stop.prevent="gotoClients">{{
          $t("nav.clients")
        }}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/contact-us" @click.stop.prevent="gotoContactUs">{{
          $t("nav.contact")
        }}</router-link>
      </li>
    </ul>

    <h5>{{ $t("nav.partnerships") }}</h5>
    <ul class="navbar-nav me-auto mt-2 mt-lg-0">
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/partnership-entrepreneur"
          @click.stop.prevent="gotoPartnershipEntrepreneur"
          >{{ $t("nav.partnership_entrepreneur") }}</router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/partnership-programmer"
          @click.stop.prevent="gotoPartnershipProgrammer"
          >{{ $t("nav.partnership_programmer") }}</router-link
        >
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/projects" @click.stop.prevent="gotoProjects">{{
          $t("nav.projects")
        }}</router-link>
      </li>
    </ul>

    <h5>{{ $t("nav.work_training") }}</h5>
    <ul class="navbar-nav me-auto mt-2 mt-lg-0">
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/training-and-mentoring-program"
          @click.stop.prevent="gotoTrainingAndMentoringProgram"
          >{{ $t("nav.training_program") }}</router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/self-learning-resources"
          @click.stop.prevent="gotoSelfLearningResources"
          >{{ $t("nav.self_learning") }}</router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/job-application"
          @click.stop.prevent="gotoJobApplication"
          >{{ $t("nav.free_positions") }}</router-link
        >
      </li>
    </ul>

    <div class="mt-4 mb-3">
      <LanguageSwitcher />
    </div>
  </div>
</template>

<script>
  import { inject } from "vue";
  import LanguageSwitcher from "./LanguageSwitcher.vue";

  export default {
    name: "HeaderMenuSection",
    components: {
      LanguageSwitcher,
    },
    setup() {
      // Inject menu state and controls from App.vue
      const menuState = inject("menuState");
      const hideMenu = inject("hideMenu");
      const showMenu = inject("showMenu");

      return {
        menuState,
        hideMenu,
        showMenu,
      };
    },
    methods: {
      gotoGeneralTerms() {
        this.hideMenu();
        this.$root.gotoGeneralTerms();
      },
      gotoSelfLearningResources() {
        this.hideMenu();
        this.$root.gotoSelfLearningResources();
      },
      gotoTrainingAndMentoringProgram() {
        this.hideMenu();
        this.$root.gotoTrainingAndMentoringProgram();
      },
      gotoProjects() {
        this.hideMenu();
        this.$root.gotoProjects();
      },
      gotoClients() {
        this.hideMenu();
        this.$root.gotoClients();
      },
      gotoServices() {
        this.hideMenu();
        this.$root.gotoServices();
      },
      gotoJobApplication() {
        this.hideMenu();
        this.$root.gotoJobApplication();
      },
      gotoPartnershipProgrammer() {
        this.hideMenu();
        this.$root.gotoPartnershipProgrammer();
      },
      gotoPartnershipEntrepreneur() {
        this.hideMenu();
        this.$root.gotoPartnershipEntrepreneur();
      },
      gotoContactUs() {
        this.hideMenu();
        this.$root.gotoContactUs();
      },
    },
  };
</script>
